/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */
const isDevelopment = Shopify.theme.role === 'development';
const fyneJewelleryJson = 'https://www.fynejewellery.com/products.json?limit=250';

const wishlistAPI = `${
	isDevelopment ? 'http://localhost:8080' : 'https://cors.vevolmedia.com'
}/fyne-jewellery/wishlist`;
const accountId = document.querySelector('.vm-customerId').value;
const accountEmail = document.querySelector('.vm-customerEmail').value;
const accountName = document.querySelector('.vm-customerName').value;
const timestamp = Date.now();
const tooltip = document.querySelectorAll('.tooltiptext');
const modal = document.querySelector('.wishlist-modal');
const cnavbarWishlistIcon = document.querySelector('.header__icon--wishlist');

const initBodyData = {
	dataSource: 'Cluster0',
	database: 'fyne-jewellery',
	collection: 'wishlist',
};

if (document.querySelector('.header__mobile__button.header__icon--wishlist')) {
	document.querySelector('.header__mobile__button.header__icon--wishlist').addEventListener('click', (e) => {
		const notLoggedIn = document.querySelector('.vm-customerId').value === '-1';

		if (notLoggedIn) {
			e.preventDefault();
			e.stopPropagation();

			modal.style.display = 'flex';
		}
	});
}

if (document.querySelector('.header__desktop__button.header__icon--wishlist')) {
	document.querySelector('.header__desktop__button.header__icon--wishlist').addEventListener('click', (e) => {
		const notLoggedIn = document.querySelector('.vm-customerId').value === '-1';

		if (notLoggedIn) {
			e.preventDefault();
			e.stopPropagation();

			modal.style.display = 'flex';
		}
	});
}

document.querySelector('.wishlist-modal__close').addEventListener('click', () => (modal.style.display = 'none'));

document.onclick = function (event) {
	if (event.target == modal) {
		modal.style.display = 'none';
	}
};

const renderTooltip = (visibility, text) => {
	tooltip.forEach((tooltipItem) => {
		tooltipItem.style.visibility = visibility;
		tooltipItem.innerText = text;
		setTimeout(() => (tooltipItem.style.visibility = 'hidden'), 1500);
	});
};

const openLoginModal = () => {
	modal.style.display = 'flex';
};
/////////////////////////////////////////////////////
/// This is the base class for establishing the account. Once called, the database responds to a new user vs. old user
class BaseWishlistAcountClass {
	async init() {
		// Don't call the database if the page is wishlist page (we have another call there)
		if (document.querySelector('wishlist-page')) {
			return;
		}

		// Render hearts if no account
		if (accountId <= 0) {
			const allHearts = document.querySelectorAll('.not-visible');
			allHearts.forEach((heart) => heart.classList.remove('not-visible'));
			return;
		}

		this.accountEntryDb = await this.getAccountEntry();

		//At the first visit, when the list is not created, one with an empty array and other useful data will be created
		if (!this.accountEntryDb?.timestamp) {
			await this.manageFirstVisit();
		} else {
			document.dispatchEvent(new Event('account-entry-set'));
		}
	}

	async getAccountEntry() {
		try {
			const res = await fetch(`${wishlistAPI}/get`, {
				method: 'POST',
				body: JSON.stringify({
					...initBodyData,
					filter: { account_id: accountId },
				}),
			});
			const resJson = await res.json();
			const wishlistIds = resJson.document?.wishlist_ids;
			const timestamp = resJson.document?.timestamp;
			const localData = {
				accountId: accountId,
				customer: { email: accountEmail, name: accountName },
				timestamp: timestamp,
				wishlistIds: wishlistIds ? wishlistIds : [],
			};
			localStorage.setItem('wishlistData', JSON.stringify(localData));
			localStorage.setItem('wishlistGetStatus', JSON.stringify(res.status));

			return localData;
		} catch (error) {
			console.error(error);
		}
	}

	async manageFirstVisit() {
		fetch(`${wishlistAPI}/create`, {
			method: 'POST',
			body: JSON.stringify({
				...initBodyData,
				document: {
					account_id: accountId,
					customer: {
						email: accountEmail,
						name: accountName,
					},
					timestamp: timestamp,
					wishlist_ids: [],
				},
			}),
		})
			.then((res) => res.json())
			.then(() => document.dispatchEvent(new Event('account-entry-set')))
			.catch((err) => console.log(err));
	}
}

//Wishlist Page Functionality
class WishlistPageFunctionality extends HTMLElement {
	constructor() {
		super();

		this.wishlistPageBtn = this.querySelector('.wishlist-product-page-button');
		this.productId = this.wishlistPageBtn.dataset.productId;
		this.wishlistPageHeart = this.querySelector('.wishlist-product-page-heart path');
		this.wishlistPageText = this.querySelector('.wishlist-product-page-btn-text');

		this.wishlistPageText = this.querySelector('.wishlist-product-page-btn-text');
		this.wishlistPageHeart = this.querySelector('.wishlist-product-page-heart path');

		this.attachListeners();
	}

	attachListeners() {
		this.wishlistPageBtn.addEventListener('click', (e) => {
			e.preventDefault();
			this.wishlistBtn();
		});

		// Display the hearts only when we have the confirmation regarding the user
		document.addEventListener('account-entry-set', () => {
			this.checkWishlist();
			this.classList.remove('not-visible');
		});
	}

	async checkWishlist() {
		try {
			// userData.accountEntryDb == our object data == localStorage data
			const list = userData.accountEntryDb;

			if (list.wishlistIds.includes(this.productId)) {
				this.wishlistPageHeart.style.fill = '#b25533';
				this.wishlistPageText.innerText = 'Remove from wishlist';
			} else {
				this.wishlistPageText.innerText = 'Add to wishlist';
			}
		} catch (error) {
			console.error(error);
		}
	}

	//ADD or Delete product id from wishlist, on click -> PRODUCT page
	async wishlistBtn() {
		if (accountId < 0) {
			openLoginModal();
			return;
		}

		this.wishlistPageBtn.disabled = true;
		this.wishlistPageBtn.style.cursor = 'progress';

		let list;
		const localList = JSON.parse(localStorage.getItem('wishlistData'));
		//in case of local storage deletion we use the data from Db
		if (localList !== null) {
			list = localList;
		} else {
			userData.init();
			list = userData.accountEntryDb;
		}

		const isProdInWishlist = list.wishlistIds.includes(this.productId);
		const wishlist = list.wishlistIds;
		const removeItem = (value) => value !== this.productId;

		if (isProdInWishlist) {
			const localData = {
				accountId: accountId,
				wishlistIds: wishlist.filter(removeItem),
			};
			localStorage.setItem('wishlistData', JSON.stringify(localData));
			this.wishlistHeartStyle('none', 'Add to wishlist', false, 'pointer');
			renderTooltip('visible', 'Product removed from wishlist');
		} else {
			const localData = {
				accountId: accountId,
				wishlistIds: [...wishlist, this.productId],
			};
			localStorage.setItem('wishlistData', JSON.stringify(localData));
			renderTooltip('visible', 'Product added to wishlist');
			this.wishlistHeartStyle('#b25533', 'Remove from wishlist', false, 'pointer');
		}

		try {
			const localList = JSON.parse(localStorage.getItem('wishlistData'));
			fetch(`${wishlistAPI}/update`, {
				method: 'POST',
				body: JSON.stringify({
					...initBodyData,
					filter: { account_id: accountId },
					update: {
						account_id: accountId,
						customer: { email: accountEmail, name: accountName },
						timestamp: timestamp,
						wishlist_ids: localList.wishlistIds,
					},
				}),
			});
		} catch (error) {
			console.error(error);
		}
	}

	wishlistHeartStyle(color, text, statusBtn, cursorType) {
		this.wishlistPageHeart.style.fill = color;
		this.wishlistPageText.innerText = text;
		this.wishlistPageBtn.disabled = statusBtn;
		this.wishlistPageBtn.style.cursor = cursorType;
	}
}

//Wishlist Collections Functionality
class WishlistCollectionsFunctionality extends HTMLElement {
	constructor() {
		super();
		this.wishlistCollectionBtns = this.querySelectorAll('.wishlist-collections-page-button');

		this.attachListeners();
	}

	async checkWishlistHearts() {
		try {
			const list = userData.accountEntryDb;

			this.wishlistCollectionBtns.forEach((btn) => {
				const wishlistCollectionHeart = btn.querySelector('.wishlist-collections-page-heart path');
				const productId = btn.dataset.productId;

				if (list.wishlistIds.includes(productId)) {
					wishlistCollectionHeart.style.fill = '#b25533';
				}
			});
		} catch (error) {
			console.error(error);
		}
	}

	attachListeners() {
		// Display the hearts only when we have the confirmation regarding the user
		document.addEventListener('account-entry-set', () => {
			this.checkWishlistHearts();
			this.classList.remove('not-visible');
		});

		this.wishlistCollectionBtns.forEach((btn) =>
			btn.addEventListener('click', async (event) => {
				event.stopImmediatePropagation();

				if (accountId < 0) {
					openLoginModal();
					return;
				}

				const wishlistCollectionHeart = btn.querySelector('.wishlist-collections-page-heart path');
				const wishlistHeartStyle = (color, text, statusBtn, cursorType) => {
					wishlistCollectionHeart.style.fill = color;
					btn.disabled = statusBtn;
					btn.style.cursor = cursorType;
				};
				const productId = btn.dataset.productId;

				btn.disabled = true;
				btn.style.cursor = 'progress';

				let list;
				const localList = JSON.parse(localStorage.getItem('wishlistData'));

				//in case of local storage deletion we use the data from Db
				if (localList !== null) {
					list = localList;
				} else {
					userData.init();
					list = userData.accountEntryDb;
				}

				const isProdInWishlist = list.wishlistIds.includes(productId);
				const wishlist = list.wishlistIds;
				const removeItem = (value) => value !== productId;

				if (isProdInWishlist) {
					const localData = {
						accountId: accountId,
						wishlistIds: wishlist.filter(removeItem),
					};
					localStorage.setItem('wishlistData', JSON.stringify(localData));
					renderTooltip('visible', 'Product removed from wishlist');
					wishlistHeartStyle('none', 'Add to wishlist', false, 'pointer');
				} else {
					const localData = {
						accountId: accountId,
						wishlistIds: [...wishlist, productId],
					};
					localStorage.setItem('wishlistData', JSON.stringify(localData));
					renderTooltip('visible', 'Product added to wishlist');
					wishlistHeartStyle('#b25533', 'Remove from wishlist', false, 'pointer');
				}

				try {
					const localList = JSON.parse(localStorage.getItem('wishlistData'));
					fetch(`${wishlistAPI}/update`, {
						method: 'POST',
						body: JSON.stringify({
							...initBodyData,
							filter: { account_id: accountId },
							update: {
								account_id: accountId,
								customer: {
									email: accountEmail,
									name: accountName,
								},
								timestamp: timestamp,
								wishlist_ids: localList.wishlistIds,
							},
						}),
					});
				} catch (error) {
					console.error(error);
				}
			})
		);
	}
}

customElements.define('wishlist-page-functionality', WishlistPageFunctionality);
customElements.define('wishlist-collections-functionality', WishlistCollectionsFunctionality);

// Call the init function only when the window is loaded, otherwise we can't select all of our elements on the page
const localStorageList = JSON.parse(localStorage.getItem('wishlistData'));
const userData = new BaseWishlistAcountClass();
window.addEventListener('load', () => userData.init());
if (localStorageList?.accountId !== accountId) {
	userData.init();
}

class EstimatedDeliveryQuickAdd extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			date: '.estimated-delivery__date',
			variantSelector: '.product-quick-add__form input[name=id]',
			variantsInventoryItems: '.variants-inventory > p',
			destinationRange: '.destination-range',
			uaeDataDelivery: '.estimated-delivery__destinations input.delivery-range-uae',
			gccDataDelivery: '.estimated-delivery__destinations input.delivery-range-gcc',
			restOfTheWorldDelivery: '.estimated-delivery__destinations input.delivery-range-rest',
			productForm: 'form.product-form[data-product-form]',
		};

		this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		this.elements = {
			uaeDataOptimisticDelivery: this.querySelector(this.selectors.uaeDataDelivery).dataset.optimisticDelivery,
			uaeDataPesimisticDelivery: this.querySelector(this.selectors.uaeDataDelivery).dataset.pesimisticDelivery,
			gccDataOptimisticDelivery: this.querySelector(this.selectors.gccDataDelivery).dataset.optimisticDelivery,
			gccDataPesimisticDelivery: this.querySelector(this.selectors.gccDataDelivery).dataset.pesimisticDelivery,
			restDataOptimisticDelivery: this.querySelector(this.selectors.restOfTheWorldDelivery).dataset
				.optimisticDelivery,
			restDataPesimisticDelivery: this.querySelector(this.selectors.restOfTheWorldDelivery).dataset
				.pesimisticDelivery,
		};

		this.inventory = {};
		this.shippingTime = {
			uae: [parseInt(this.elements.uaeDataOptimisticDelivery), parseInt(this.elements.uaeDataPesimisticDelivery)],
			gcc: [parseInt(this.elements.gccDataOptimisticDelivery), parseInt(this.elements.gccDataPesimisticDelivery)],
			world: [
				parseInt(this.elements.restDataOptimisticDelivery),
				parseInt(this.elements.restDataPesimisticDelivery),
			],
		};

		this.init();

		document.addEventListener('quick-add:modal-open', () => {
			this.init();
		});

		document.addEventListener('theme:variant:change', () => this.init());
	}
	init() {
		this.getVariantsInventory();
		this.getEstimations();
	}

	getVariantsInventory() {
		this.querySelectorAll(this.selectors.variantsInventoryItems).forEach((variant) => {
			const variantId = variant.children[0].textContent;
			const variantStock = +variant.children[1].textContent;

			this.inventory[variantId] = variantStock;
		});
	}

	getSelectedVariant() {
		// Build selected variant using all selected options
		// Return in a readable way so we can locate it by name
		let selectedOptions;

		selectedOptions = document.querySelector(this.selectors.variantSelector).value;
		return selectedOptions;
	}

	getEstimations() {
		const selectedVariant = this.getSelectedVariant();
		const isVariantInStock = this.inventory[selectedVariant] > 0;
		const productionTime = isVariantInStock ? [0, 0] : [10, 14]; // 0 days for items in stock and 7-10 days for made to order items

		let today = new Date();

		let deliveryDates = [];

		this.querySelectorAll(this.selectors.destinationRange).forEach((el, i) => {
			const region = el.dataset.destination;

			const optimisticShippingDays = this.shippingTime[region][0];
			const pessimisticShippingDays = this.shippingTime[region][1];

			const optimisticDeliveryDate = this.calculateDeliveryDate(today, productionTime[0], optimisticShippingDays);

			const pessimisticDeliveryDate = this.calculateDeliveryDate(
				today,
				productionTime[1],
				pessimisticShippingDays
			);

			const optimisticFinal = this.formatDate(optimisticDeliveryDate);
			const pesimisticFinal = this.formatDate(pessimisticDeliveryDate);

			function splitDate(dateString) {
				const [day, month] = dateString.split(' ');
				return { day: parseInt(day), month };
			}

			const optimisticDate = splitDate(optimisticFinal);
			const pessimisticDate = splitDate(pesimisticFinal);

			if (optimisticDate.day === pessimisticDate.day) {
				pessimisticDate.day += 1;
			}

			const updatedPessimisticFinal = `${pessimisticDate.day} ${pessimisticDate.month}`;

			if (optimisticFinal == pesimisticFinal) {
				el.textContent = `${optimisticFinal} - ${updatedPessimisticFinal}`;
			} else {
				el.textContent = `${optimisticFinal} - ${pesimisticFinal}`;
			}

			let regionName = Object.keys(this.shippingTime)[i].toUpperCase();
			let deliveryDate = regionName + ' ' + el.textContent;

			deliveryDates.push(deliveryDate);
		});

		const deliveryText = deliveryDates.join(' | ');
		this.addProductProprety(deliveryText);
	}

	addProductProprety(deliveryText) {
		const quickAddDialog = this.closest('dialog.product-quick-add[data-quick-add-modal]');
		if (!quickAddDialog) return;

		const productForm = quickAddDialog.querySelector(this.selectors.productForm);
		if (!productForm) return;

		const existing = productForm.querySelector("input[name='properties[Estimated delivery]']");
		if (existing) existing.remove();

		if (deliveryText) {
			const inputText = document.createElement('input');
			inputText.type = 'hidden';
			inputText.name = 'properties[Estimated delivery]';
			inputText.value = deliveryText;
			productForm.appendChild(inputText);
			productForm.dataset.productAdditionalPropertyEstimatedDelivery = deliveryText;
		} else {
			delete productForm.dataset.productAdditionalPropertyEstimatedDelivery;
		}
	}

	calculateDeliveryDate(today, productionDays, shippingDays) {
		const outOfHours = today.getHours() > 16 ? 1 : 0;
		const totalDaysToAdd = productionDays + shippingDays + outOfHours;

		const deliveryDate = new Date(today.getTime() + totalDaysToAdd * 24 * 60 * 60 * 1000);

		const deliveryDateOusideWeekends = this.calculateWeekends(deliveryDate);

		return deliveryDateOusideWeekends;
	}

	calculateWeekends(today) {
		let cutoutDays = 0;

		switch (today.getDay()) {
			case 6: // Saturday
				cutoutDays += 2;
				break;
			case 0: // Sunday
				cutoutDays += 1;
			default:
				break;
		}

		return new Date(today.setDate(today.getDate() + cutoutDays));
	}

	formatDate(date) {
		return `${date.getDate()} ${this.months[date.getMonth()]}`;
	}
}

customElements.define('estimated-delivery-quick-add', EstimatedDeliveryQuickAdd);

class EstimatedDeliveryPreoderQuickAdd extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			destinationRange: '.preoder-date',
			productForm: 'form.product-form[data-product-form]',
			preoderDate: '.estimated-delivery__destinations input.preoder-date--world',
		};

		this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		this.elements = {
			preoderDelivery: this.querySelector(this.selectors.preoderDate).dataset.preoderDelivery,
		};

		this.init();

		document.addEventListener('quick-add:modal-open', () => {
			this.init();
		});
	}

	init() {
		this.getEstimations();
	}

	getEstimations() {
		const today = new Date();
		let deliveryDateText;

		this.querySelectorAll(this.selectors.destinationRange).forEach((el) => {
			const preoderDeliveryDate = this.calculateDeliveryDate(today, parseInt(this.elements.preoderDelivery, 10));

			el.textContent = this.formatDate(preoderDeliveryDate);
			deliveryDateText = el.textContent;
		});

		this.addProductProprety(deliveryDateText);
	}

	addProductProprety(deliveryText) {
		const quickAddDialog = this.closest('dialog.product-quick-add[data-quick-add-modal]');
		if (!quickAddDialog) return;

		const productForm = quickAddDialog.querySelector(this.selectors.productForm);
		if (!productForm) return;

		const existing = productForm.querySelector("input[name='properties[Estimated delivery]']");
		if (existing) existing.remove();

		if (deliveryText) {
			const inputText = document.createElement('input');
			inputText.type = 'hidden';
			inputText.name = 'properties[Estimated delivery]';
			inputText.value = deliveryText;
			productForm.appendChild(inputText);
			productForm.dataset.productAdditionalPropertyEstimatedDelivery = deliveryText;
		} else {
			delete productForm.dataset.productAdditionalPropertyEstimatedDelivery;
		}
	}

	calculateDeliveryDate(today, shippingDays) {
		const outOfHours = today.getHours() > 16 ? 1 : 0;
		const totalDaysToAdd = shippingDays + outOfHours;

		const deliveryDate = new Date(today.getTime() + totalDaysToAdd * 24 * 60 * 60 * 1000);

		return this.calculateWeekends(deliveryDate);
	}

	calculateWeekends(date) {
		let cutoutDays = 0;
		const day = date.getDay();

		if (day === 6) cutoutDays = 2; // Saturday
		else if (day === 0) cutoutDays = 1; // Sunday

		if (cutoutDays) date.setDate(date.getDate() + cutoutDays);
		return date;
	}

	formatDate(date) {
		return `${date.getDate()} ${this.months[date.getMonth()]}`;
	}
}

customElements.define('estimated-delivery-preoder-quick-add', EstimatedDeliveryPreoderQuickAdd);
